import { get } from '@services/method';
import { IAccount } from '@models';
import routes from '@configs/routes.json';

export const getAccounts = (): Promise<IAccount[]> => {
  return get(routes.api.accountsV2.get).then((response) => response.json());
};
